import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { articles, hotRanks } from "@/mocks/gossip";
import ArticleCard from "@/components/feature/ArticleCard";

const FILTERS = [
  { key: "all", label: "全部热议" },
  { key: "zongyi", label: "综艺" },
  { key: "yingshi", label: "影视" },
  { key: "yinyue", label: "乐坛" },
  { key: "guancha", label: "观察" },
];

const RANK_LABEL: Record<string, string> = {
  zongyi: "综艺",
  yingshi: "影视",
  yinyue: "乐坛",
  guancha: "观察",
};

export default function HotFeeds({ query, onClearQuery }: { query: string; onClearQuery: () => void }) {
  const [filter, setFilter] = useState("all");

  const matched = useMemo(() => {
    const q = query.toLowerCase();
    return articles
      .filter((a) => (filter === "all" ? true : a.category === filter))
      .filter((a) => (q ? (a.title + a.summary + a.tags.join()).toLowerCase().includes(q) : true));
  }, [filter, query]);

  return (
    <section id="gualiao" className="w-full scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8 lg:px-12">
        <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
              LIVE 实时更新
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              实时热榜与热门瓜料
            </h2>
          </div>
          {query && (
            <button
              type="button"
              onClick={onClearQuery}
              className="mt-2 inline-flex cursor-pointer items-center gap-1 self-start text-sm font-medium text-primary-600 md:mt-0"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              正在搜索“{query}”，共 {matched.length} 条
            </button>
          )}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* 热榜 */}
          <aside className="lg:col-span-4" aria-label="实时热榜">
            <div className="rounded-3xl border border-background-200/70 bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                  <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className="ri-fire-fill text-sm" aria-hidden="true"></i>
                  </span>
                  实时热榜
                </h3>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-900">
                  每5分钟刷新
                </span>
              </div>

              <ol className="mt-5 space-y-1.5">
                {hotRanks.map((r) => (
                  <li key={r.no}>
                    <Link
                      to={`/detail/${r.articleId}`}
                      className="group flex items-start gap-3 rounded-xl px-2 py-2.5 transition-colors hover:bg-secondary-100"
                    >
                      <span
                        className={
                          "mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-sm font-black " +
                          (r.no <= 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-100 text-secondary-700")
                        }
                      >
                        {r.no}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                          {r.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                          <i className="ri-arrow-up-line text-primary-500" aria-hidden="true"></i>
                          热度上升中 · {RANK_LABEL[r.category]}
                        </span>
                      </span>
                      <span
                        className={
                          "shrink-0 rounded-md px-1.5 py-0.5 text-[11px] font-bold " +
                          (r.tag === "爆"
                            ? "bg-primary-100 text-primary-700"
                            : r.tag === "热"
                              ? "bg-accent-100 text-accent-800"
                              : "bg-secondary-100 text-secondary-700")
                        }
                      >
                        {r.tag}
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </aside>

          {/* 资讯流 */}
          <div className="lg:col-span-8">
            <div className="mb-5 flex flex-wrap items-center gap-2">
              {FILTERS.map((f) => (
                <button
                  key={f.key}
                  type="button"
                  onClick={() => setFilter(f.key)}
                  className={
                    "cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors " +
                    (filter === f.key
                      ? "bg-foreground-950 text-background-50"
                      : "bg-background-200 text-foreground-600 hover:bg-background-300 hover:text-foreground-900")
                  }
                >
                  {f.label}
                </button>
              ))}
            </div>

            {matched.length === 0 ? (
              <div className="flex flex-col items-center justify-center rounded-3xl border border-dashed border-background-300 bg-background-50 px-6 py-20 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-ghost-fill text-2xl" aria-hidden="true"></i>
                </span>
                <p className="mt-4 font-heading text-lg font-bold text-foreground-900">
                  这个瓜还没熟透
                </p>
                <p className="mt-1 max-w-sm text-sm text-foreground-500">
                  没有找到与当前筛选匹配的内容，换个分类或换个关键词试试吧。
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setFilter("all");
                    onClearQuery();
                  }}
                  className="mt-5 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-refresh-line" aria-hidden="true"></i> 回到全部热议
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                {matched.map((item) => (
                  <ArticleCard key={item.id} item={item} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}